import { useMutation } from "@shared/lib/hooks";

import { ToastService } from "@shared/lib/services";
import { ReportService } from "../services/Report.servie";

export function useAddMediaReport(
  reportId: string,
  handleSuccess?: () => void
) {
  const {
    mutate: addMedia,
    isLoading: isAdding,
    isSuccess: isAdded,
  } = useMutation({
    mutationFn: async ({ link }: { link: string }) => {
      return await ReportService.addMediaReport({ link, reportId }).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, _) => {
      handleSuccess?.();
      // c.invalidateQueries({ queryKey: [REPORTS_LIST_QUERY_KEY, reportId] });
    },
  });
  return {
    addMedia,
    isAdding,
    isAdded,
  };
}
